import React from "react";
import SvgFrag from "./../../images/frag-axe.svg"
import ImageFrag1 from "./../../images/A3xF1_N024644.jpg"
import ImageFrag2 from "./../../images/A3xF2_N024554.jpg"
import ImageFrag3 from "./../../images/A3xF3_N015292.jpg"
import ImageFrag4 from "./../../images/A3xF4_N024512.jpg"
import ImageFrag5 from "./../../images/fragment-manquant.svg"

const openModal = (ev) => {
    console.log('test');
    var target = ev.target;
    if (target.classList.contains('frag--container')){
    } else if (target.parentNode.classList.contains('frag--container')){
        target = target.parentNode;
    } else if (target.parentNode.parentNode.classList.contains('frag--container')){
        target = target.parentNode.parentNode;
    } else if (target.parentNode.parentNode.parentNode.classList.contains('frag--container')){
        target = target.parentNode.parentNode.parentNode;
    }
    target.classList.toggle('show');
}

export default () => (
  <div className="frag--wrapper">
      <div className="frag--container" onClick={openModal}>
        <SvgFrag/>
        <span className="frag--label">F1</span>
        <div className="frag--modal">
            <div className="frag--content">
                <img src={ImageFrag1} alt=""/>
                <span>Sillonnant l&#39;arrondissement de Beauport. Photographe inconnu, Fonds W.B. Edwards inc, AVQ, 1974.</span>
            </div>
        </div>
     </div>
     <div className="frag--container" onClick={openModal}>
        <SvgFrag/>
        <span className="frag--label">F2</span>
        <div className="frag--modal">
            <div className="frag--content">
                <img src={ImageFrag2} alt=""/>
                <span>La Capitale aux abords du quartier Les Saules. Photographe inconnu, Fonds W.B. Edwards inc, AVQ, 1973.</span>
            </div>
        </div>
     </div>
     <div className="frag--container" onClick={openModal}>
        <SvgFrag/>
        <span className="frag--label">F3</span>
        <div className="frag--modal">
            <div className="frag--content">
                <img src={ImageFrag3} alt=""/>
                <span>La Capitale pendant la construction, secteur Lebourgneuf. Photographe inconnu, Fonds de la Ville de Québec, AVQ, 1973.</span>
            </div>
        </div>
     </div>
     <div className="frag--container" onClick={openModal}>
        <SvgFrag/>
        <span className="frag--label">F4</span>
        <div className="frag--modal">
            <div className="frag--content">
                <img src={ImageFrag4} alt=""/>
                <span>La Capitale au croisement avec l&#39;autoroute Laurentienne. Photographe inconnu, Fonds W.B. Edwards inc, AVQ, 1973.</span>
            </div>
        </div>
     </div>
     <div className="frag--container" onClick={openModal}>
        <SvgFrag/>
        <span className="frag--label">F5</span>
        <div className="frag--modal missing">
            <div className="frag--content">
                <ImageFrag5/>
                <span>Avec la nouvelle ligne de Tram, La Capitale est délaissée par les automobilistes. Photographe inconnu, année à venir.</span>
            </div>
        </div>
     </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/components/frag-axe3.js